import { TextField, FormLabel } from '@mui/material';
import React from 'react';
import "../../styles/component/input.scss"


const InputComponent = ({
    className,
    label,
    type,
    placeholder,
    name,
    value,
    onChange,
    padding,
    borderColor,
    placeholderColor,
    error,
    helperText,
    InputProps,
    bordersize,
    id,
    handleKeyPress,
    disabled = false,
    isAuth = false
}) => {
    return (
        <div className='w-100'>
            <FormLabel
                className="label"
                sx={{
                    paddingTop: "1.25rem",
                    paddingBottom: "10px",
                    display: "inline-block",
                    color: "#000",
                }}
            >
                {label}
            </FormLabel>

            <TextField
                id={id}
                name={name}
                type={type}
                className={className}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                variant="outlined"
                fullWidth
                disabled={disabled}
                error={error}
                helperText={helperText}
                slotProps={{
                    input: {
                        endAdornment: InputProps?.endAdornment,
                        classes: {
                            input: 'user-input',  // Apply custom class to the input field
                        },
                    },
                    formHelperText: {
                        sx: {
                            color: error ? "#d32f2f" : "#F5D01C",
                            margin: "5px 0 0 0 ",
                            fontSize: "14px",
                            fontFamily: "Poppins"
                        }
                    }
                }}
                sx={
                    isAuth ?
                        // {
                        //     "& .MuiOutlinedInput-root": {
                        //         position: "relative",
                        //         borderRadius: "10px",
                        //         // Gradient border using ::before (does not affect icon)
                        //         "&::before": {
                        //             content: '""',
                        //             position: "absolute",
                        //             inset: 0,
                        //             padding: "2px",
                        //             background: "linear-gradient(to right, #F5D01C, #826320)",
                        //             WebkitMask:
                        //                 "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                        //             WebkitMaskComposite: "xor",
                        //             maskComposite: "exclude",
                        //             pointerEvents: "none",
                        //             borderRadius: "10px",
                        //         },
                        //         // Inner white background (including icon area)
                        //         "& .MuiOutlinedInput-notchedOutline": {
                        //             border: "none",
                        //         },
                        //         "& input": {
                        //             backgroundColor: "#fff",
                        //             borderRadius: "8px",
                        //         },
                        //         // Fix for the icon (white BG, no border bleed)
                        //         "& .MuiInputAdornment-root": {
                        //             borderRadius: "0 8px 8px 0",
                        //             height: "calc(100% - 4px)",
                        //             paddingLeft: "8px",
                        //         },
                        //         "& .MuiIconButton-root": {
                        //             "&:hover": {
                        //                 backgroundColor: "#f5f5f5",
                        //             },
                        //         },
                        //     },
                        // }
                        {
                            "& .MuiOutlinedInput-root": {
                                position: "relative",
                                borderRadius: "10px",
                                // Default gradient (yellow to brown)
                                "&::before": {
                                    content: '""',
                                    position: "absolute",
                                    inset: 0,
                                    padding: "2px",
                                    background: error
                                        ? "#d32f2f" // Solid red for error
                                        : "linear-gradient(to right, #F5D01C, #826320)", // Default gradient
                                    WebkitMask:
                                        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                                    WebkitMaskComposite: "xor",
                                    maskComposite: "exclude",
                                    pointerEvents: "none",
                                    borderRadius: "10px",
                                },
                                // Inner white background
                                "& .MuiOutlinedInput-notchedOutline": {
                                    border: "none",
                                },
                                "& input": {
                                    backgroundColor: "#fff",
                                    borderRadius: "8px",
                                },
                                // Icon styling (unchanged)
                                "& .MuiInputAdornment-root": {
                                    borderRadius: "0 8px 8px 0",
                                    height: "calc(100% - 4px)",
                                    paddingLeft: "8px",
                                },
                                "& .MuiIconButton-root": {
                                    "&:hover": {
                                        backgroundColor: "#f5f5f5",
                                    },
                                },
                            },
                            // Error message styling
                            "& .MuiFormHelperText-root": {
                                color: error ? "#d32f2f" : "#F5D01C", // Red for error, yellow for normal
                            },
                        }
                        :
                        {
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                "& fieldset": {
                                    border: `${bordersize ? bordersize : "2px"} solid ${borderColor || "#14A9E2"}`,
                                },
                                "&:hover fieldset": {
                                    borderColor: error ? "#d32f2f" : borderColor || "#14A9E2",
                                },
                                "&.Mui-focused fieldset": {
                                    borderColor: error ? "#d32f2f" : "#14A9E2",
                                },
                            },
                            "& .MuiInputBase-input": {
                                padding: padding || "15.5px 12px",
                                "&::placeholder": {
                                    color: error ? "#d32f2f" : placeholderColor || "#14A9E2",
                                    opacity: 1,
                                    fontSize: "16px",
                                },
                            },
                        }
                }
                onKeyPress={handleKeyPress}
            />
        </div>
    );
};

export default InputComponent;
